import {Palette, Theme, ThemeOptions, TypeAction, TypeBackground, TypeText} from "@mui/material";

export interface CustomTheme extends Theme {
  palette: CustomPalette;
}

export interface CustomThemeOptions extends ThemeOptions {
  palette: CustomPalette
}

export interface CustomPalette extends Palette {
  text: CustomTypeText;
  background: CustomTypeBackground;
  navigation: CustomNavigation;
  card: CustomTypeBackground;
  flex: CustomProperty;
  consumption: CustomProperty;
  production: CustomProperty;
  grid: CustomProperty;
  profit: CustomProperty;
  epex: CustomProperty;
  imbPrice: CustomProperty;
  soc: CustomProperty,
  forecast: CustomProperty
}

interface CustomTypeText extends TypeText {
  tertiary: string;
}

interface CustomTypeBackground extends TypeBackground {
  navbar: string;
  dashboard: string;
}

interface CustomNavigation {
  selected: string;
}

interface CustomProperty {
  main: string;
  secondary: string;
}

export const themeOptions: CustomThemeOptions = {
  typography: {
    fontFamily: "'Lato', 'Tahoma', sans-serif",
    h1: {
      fontFamily: "'Space Grotesk', 'Tahoma', sans-serif",
    },
    h2: {
      fontFamily: "'Space Grotesk', 'Tahoma', sans-serif",
    },
    h3: {
      fontFamily: "'Space Grotesk', 'Tahoma', sans-serif",
    },
    h4: {
      fontFamily: "'Space Grotesk', 'Tahoma', sans-serif",
    },
    h5: {
      fontFamily: "'Space Grotesk', 'Tahoma', sans-serif",
    },
    h6: {
      fontFamily: "'Space Grotesk', 'Tahoma', sans-serif",
    },
  },
  palette: {
    primary: {
      main: 'rgb(255, 26, 61)', // Main red color
    },
    secondary: {
      main: 'rgb(255, 71, 94)', // Red 80%
    },
    text: {
      primary: '#444444',
      secondary: '#FFFFFF',
      tertiary: '#888888'
    } as CustomTypeText,
    background: {
      default: '#F4F4F4',
      dashboard: '#F4F4F4',
      navbar: '#F4F4F4'
    } as CustomTypeBackground,
    navigation: {
      selected: 'rgb(237, 237, 238)' // Grey for selected navigation
    } as CustomNavigation,
    card: {
      default: '#FFFFFF'
    } as CustomTypeBackground,
    consumption: {
      main: "#FF1A3D",
    } as CustomProperty,
    production: {
      main: "#009975",
      secondary: "#999"
    } as CustomProperty,
    flex: {
      main: "#ee7486",
      secondary: "#66D7B7"
    } as CustomProperty,
    grid: {
      main: "#ee7486",
      secondary: "#66D7B7"
    } as CustomProperty,
    epex: {
      main: "rgb(255, 26, 61)",
    } as CustomProperty,
    imbPrice: {
      main: "#999"
    } as CustomProperty,
    soc: {
      main: "#009975",
    } as CustomProperty,
    forecast: {
      main: '#7c7c7c',
      secondary: 'black'
    } as CustomProperty,
  } as CustomPalette,
};
